export interface State {
  calendarConfiguration: CalendarConfigurationConfig;
  configurationLoading: boolean;
}

export interface CalendarConfigurationConfig {
  delta: CompsetDeltaOptions;
  compsetPriceType: CompsetPriceTypes;
}

export enum CompsetPriceTypes {
  MEDIAN = 'MEDIAN',
  AVERAGE = 'AVERAGE',
  WEIGHTED_AVERAGE = 'WEIGHTED_AVERAGE',
}


export type CompsetDeltaOptions = 1 | 3 | 7 | 14 | 30;
